export default __webpack_public_path__ + "static/media/list_main_11_2.44094a7e.jpg";